import { render, staticRenderFns } from "./LoadingLogo.vue?vue&type=template&id=5bcc747b&scoped=true&"
import script from "./LoadingLogo.vue?vue&type=script&lang=js&"
export * from "./LoadingLogo.vue?vue&type=script&lang=js&"
import style0 from "./LoadingLogo.vue?vue&type=style&index=0&id=5bcc747b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc747b",
  null
  
)

export default component.exports